import { createAction } from '@reduxjs/toolkit';
export const START_CALL_RECORDING = 'START_CALL_RECORDING';
export const startCallRecordingAction = createAction(START_CALL_RECORDING);